import React from 'react';
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types';
import { reduxForm, submit } from 'redux-form'
import SpaceDetails from './space-details'
import SpaceAmenities from './space-amenities'
import SpaceImages from './space-images'
import validate from './validator'

const SpaceActionForm = ({ form, dispatch }) => {
  const syncErrors = useSelector((state) => state.form[form].syncErrors);
  return (
    <>
      <SpaceDetails form={form} />
      <SpaceAmenities form={form} />
      <SpaceImages form={form} />
      <div className="text-center">
        <button onClick={() => !syncErrors && dispatch(submit(form))} className={`${syncErrors ? 'w-full md:w-2/12 text-white px-2 py-3 rounded-b-lg md:rounded-lg focus:outline-none bg-primary-lightgray' : 'w-full md:w-2/12 text-white px-2 py-3 rounded-b-lg md:rounded-lg focus:outline-none bg-primary-orange'}`}>SAVE SPACE</button>
      </div>
    </>
  )
}

SpaceActionForm.propTypes = {
  form: PropTypes.string,
  dispatch: PropTypes.func,
};


export default reduxForm({ validate, enableReinitialize: true })(connect()(SpaceActionForm))
